import {
	Button, Modal as ChakraModal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay
} from '@chakra-ui/react';
import React from 'react';

type ModalProps = {
	title: string;
	isOpen: boolean;
	onSubmit: ModalSaveEventHandler;
	onCancel: ModalCancelEventHandler;
	initialRef: any;
}

export type ModalSaveEventHandler = () => void;
export type ModalCancelEventHandler = () => void;

const Modal: React.FC<ModalProps> = ({
	initialRef,
	title,
	children,
	isOpen,
	onSubmit,
	onCancel,
}) => {
	return (
		<ChakraModal
			size="lg"
			initialFocusRef={initialRef}
			// finalFocusRef={finalRef}
			isOpen={isOpen}
			onClose={onCancel}
		>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{title}</ModalHeader>
				<ModalCloseButton />
				<ModalBody pb={4}>
					{children}
				</ModalBody>
				<ModalFooter>
					<Button
						colorScheme="blue"
						mr={3}
						onClick={onSubmit}
					>
						Save
					</Button>
					<Button onClick={onCancel}>
						Cancel
					</Button>
				</ModalFooter>
			</ModalContent>
		</ChakraModal>
	);
};

export default Modal;
